import { IInputItems, TissTipoPessoa } from '@/typings';

export const tipoPessoa: IInputItems[] = [
  { label: 'JURÍDICA', value: TissTipoPessoa.JURIDICA },
  { label: 'FÍSICA', value: TissTipoPessoa.FISICA },
];
